var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"warning--header"},[_vm._v("Wait a second!")]),_vm._v(" "),_c('p',{staticClass:"p-s-24"},[_vm._v("\n    This provider requires that you take a tour before you can join their waitlist.\n  ")])])
}]

export { render, staticRenderFns }